// extracted by css-extract-rspack-plugin
module.exports =  {"normal":"FormButton-module__normal","active":"FormButton-module__active","disabled":"FormButton-module__disabled"};